import { API_BASE } from './api';

const BASE_URL = `${API_BASE}/quit-plan`;

async function parseResponse(res, fallbackMessage) {
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.message || fallbackMessage);
  }

  return data;
}

export async function fetchQuitPlan() {
  const res = await fetch(BASE_URL, {
    method: 'GET',
    credentials: 'include',
  });

  return parseResponse(res, 'Failed to load quit plan.');
}

export async function generateQuitPlan(inputs) {
  const res = await fetch(`${BASE_URL}/generate`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(inputs),
  });

  return parseResponse(res, 'Failed to generate quit plan.');
}

export async function generateQuitPlanFromCheckIn(payload = {}) {
  const res = await fetch(`${BASE_URL}/generate-from-checkin`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  return parseResponse(res, 'Failed to generate quit plan from check-in.');
}

export async function updateQuitPlan(payload) {
  const res = await fetch(BASE_URL, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  return parseResponse(res, 'Failed to update quit plan.');
}

export async function updateQuitPlanEdits(edits) {
  return updateQuitPlan({ edits });
}
